
























































































































































































import { Vue, Component } from 'vue-property-decorator'
import { Checkbox } from 'element-ui'
import { applyUserInfo, getCertifiInfo } from '@/services/apply'
import { CHECK_STATUS } from '@/constants/applyForm'
import { userInfoForm } from '@/constants/applyForm'
@Component({
  components: {
    Checkbox,
  },
})
export default class Read extends Vue {
  accepted: Boolean = false
  $toast: any
  formData: ApplyTypes.UserInfoForm = userInfoForm
  avtImage: string = ''
  CHECK_STATUS = CHECK_STATUS

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  get userInfo() {
    return this.$store.state.userInfo
  }

  async handleSubmit() {
    if (!this.accepted) {
      this.$toast('请先阅读并接受《芒果TV创作公约》')
    } else {
      try {
        const res = await applyUserInfo({
          ...this.formData,
          uuid: this.userInfoInapp.uuid,
          ticket: this.userInfoInapp.ticket,
          avatar: this.avtImage,
          accountType: 1,
        })

        if (res && res.code == 200) {
          // this.publishSuccess = true
          this.$emit('goNext')
        } else {
          // this.$toast(res.msg)
          this.$emit('goNext')
        }

        const { uuid, ticket } = this.userInfoInapp
        // this.$store.commit('UpdateUserApplyStatus', CHECK_STATUS.AUDITINT)
        this.$store.dispatch('getColumnistInfoAction', { uuid, ticket })
      } catch (error) {
        console.log(error)
      }
    }
  }
  mounted() {
    this.getSettedInfo()
  }
  async getSettedInfo() {
    const res = await getCertifiInfo({
      uuid: this.userInfoInapp.uuid,
    })
    if (res.code === 200) {
      if (res.data && res.data.nickname !== '') {
        let resData = res.data
        console.log('resData', resData)
        this.formData.nickname = resData.nickname
        this.formData.introduction = resData.introduction
        this.avtImage = resData.avatar
      }
    }
  }
}
